// Tiny GA4 helper — wraps gtag with safe fallbacks for SSR/dev.

const GA_ID = "G-1PPL7Z95ZF";

const gtagAvailable = () =>
  typeof window !== "undefined" && typeof window.gtag === "function";

// Track a page view (called from Layout on route change)
export const trackPageView = (path) => {
  if (!gtagAvailable()) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
    send_to: GA_ID,
  });
};

// Track a contact click (call / whatsapp / text)
export const trackContactClick = (method, location, extra = {}) => {
  if (!gtagAvailable()) return;
  // Google's standard "generate_lead" event so it surfaces in GA's Reports/Conversions
  window.gtag("event", "generate_lead", {
    method,         // 'call' | 'whatsapp' | 'text'
    location,       // 'navbar' | 'hero' | 'sticky' | 'contact_card' | 'contact_service' | 'final_cta'
    ...extra,       // optional 'service' field on contact page selector
    send_to: GA_ID,
  });
  // Also send a more granular event for easier filtering in Explorations
  window.gtag("event", `click_${method}`, {
    location,
    ...extra,
    send_to: GA_ID,
  });
};
